export function createTrainingInstructionRecordTableFields (vm) {
  return [
    { key: 'id', prop: 'id', label: '记录ID', width: 90 },
    { key: 'instruction_id', label: '培训ID', width: 90, formatter: () => vm.instruction.id },
    {
      key: 'training_instruction_title',
      prop: 'training_instruction_title',
      label: '培训标题',
      minWidth: 160,
      showOverflowTooltip: true,
    },
    { key: 'userid', label: '用户ID', width: 90, formatter: row => row.userid },
    { key: 'realname', prop: 'realname', label: '真实姓名', minWidth: 100, showOverflowTooltip: true },
    { key: 'region_name', prop: 'region_name', label: '省市区', minWidth: 160, showOverflowTooltip: true },
    {
      key: 'target_usertype',
      label: '用户类型',
      width: 110,
      slot: 'tag',
      formatter: row => row.target_usertype_name,
      tagClass: row => vm.getUserTypeTagClass(row.target_usertype),
    },
    {
      key: 'source_type',
      label: '来源',
      width: 120,
      slot: 'tag',
      formatter: row => row.source_type_name,
      tagClass: row => vm.getSourceTypeTagClass(row.source_type),
    },
    { key: 'project', label: '项目', minWidth: 160, slot: 'project' },
    { key: 'batch', label: '批次', minWidth: 160, slot: 'subId', nameKey: 'batch_name', idKey: 'batchid' },
    { key: 'task', label: '任务', minWidth: 160, slot: 'subId', nameKey: 'task_title', idKey: 'taskid' },
    {
      key: 'instruction_record_status',
      label: '培训状态',
      width: 110,
      slot: 'tag',
      formatter: row => row.instruction_record_status_name,
      tagClass: row => vm.getRecordStatusTagClass(row.instruction_record_status),
    },
    { key: 'learning_progress', label: '学习进度', width: 180, slot: 'progress' },
    { key: 'examination_score', label: '考试分数', width: 100, slot: 'score' },
    { key: 'learning_started_at', label: '开始学习时间', width: 170, slot: 'datetime', prop: 'learning_started_at' },
    { key: 'learning_finished_at', label: '完成学习时间', width: 170, slot: 'datetime', prop: 'learning_finished_at' },
    { key: 'examination_submitted_at', label: '考试提交时间', width: 170, slot: 'datetime', prop: 'examination_submitted_at' },
  ]
}



// WEBPACK FOOTER //
// ./src/views/training/training-instruction-record-table.fields.js